import { z } from 'zod'

/**
 * Which side of a question thread the viewer is on. A message author can also
 * be staff (`QuestionAuthorType`); a signing or answerer session cannot.
 */
export const QUESTION_ROLES = ['asker', 'answerer'] as const

export const questionRoleSchema = z.enum(QUESTION_ROLES)

export type QuestionRole = z.infer<typeof questionRoleSchema>
